/**
 * ADR-118 «Поток сообщений v2» — контрактная часть: модель хода
 * (Turn → Step → Part), контракт приёма сообщения и payload'ы новых событий
 * шины сессии.
 *
 * Модуль browser-safe: только типы и чистые функции, без node-зависимостей —
 * используется и в ядре, и в UI (сверка возможностей инстанса).
 *
 * Решения ADR-118, которые здесь закреплены:
 * - п. 3 — `POST /api/v2/sessions/:id/prompt` всегда отвечает `202
 *   {messageId, mode, position}` (см. `PromptAcceptedResponse`);
 * - п. 4 — набор новых событий (`message.accepted`/`queue.state`/
 *   `message.delivered`/`turn.*`/`step.*`/`part.*`) с payload'ами ниже;
 * - п. 5 — «финал» = смена статуса сообщения (`MessageStatus`), а не замена
 *   объекта;
 * - п. 8 — сверка возможностей клиента и сервера (fail-closed) через
 *   `GET /api/v2/meta` → `InstanceCapabilities`.
 */
/**
 * ADR-118 §8: версия модели сообщений/потока, которую понимает клиент.
 * Инстанс сообщает свою версию в `GET /api/v2/meta`
 * (`InstanceCapabilities.messageModel`).
 */
export const MESSAGE_MODEL_VERSION = 2;
/**
 * ADR-118 §8: имя query-параметра, которым клиент заявляет свою модель
 * сообщений (`GET /api/v2/events?messageModel=2`).
 *
 * Константа живёт в `shared`, потому что её знают и клиент (UI/SDK), и
 * сервер (гибридный мост `RemoteEventBridge`, `remote/event-bridge.ts`).
 */
export const MESSAGE_MODEL_QUERY_PARAM = 'messageModel';
/**
 * ADR-118 §8: поддерживает ли инстанс текущую модель сообщений.
 *
 * Сверка **fail-closed**: отсутствие поля `messageModel` (старый инстанс) или
 * иное значение → `false` (отказ подключения, а не тихая деградация).
 */
export function supportsMessageModel(capabilities) {
    return capabilities?.messageModel === MESSAGE_MODEL_VERSION;
}
